<template>
    <div class="clearfix"></div>
    <div class="container-fluid text-center mt-5 border-top">
        <div class="row">
            <div class="col">
                <div class="text-center mt-2 small text-black-50">&copy; Michael Staroste, 2023. All rights reserved.</div>
            </div>
        </div>
    </div>
</template>